import { create } from 'zustand'

interface EmotionRatingState {
  byUserId: Record<string, number>
  setRatings: (m: Record<string, number>) => void
}
export const useEmotionRatingStore = create<EmotionRatingState>((set) => ({
  byUserId: {},
  setRatings: (byUserId) => set({ byUserId }),
}))
